<ul class="language-dropdown-wrapper" [class.language-dropdown-wrapper-globe]="iconStyle === 'globe'" (click)="onDropdownClick($event)">
    <li class="dropdown" [class.open]="showLanguageMenu">
        <a href="javascript:void(0);" class="dropdown-toggle" (click)="toggleLanguageMenu()">
            <i *ngIf="iconStyle === 'globe'" class="ph ph-globe-simple"></i>
            <img *ngIf="iconStyle === 'flag'" [src]="getFlagUrlByLang(currentLanguageLabel)" width="20" height="14"
                style="border-radius: 5px; margin-right: 6px;" />
            <span class="dropdown-toggle-label">{{ currentLanguageLabel }}</span>
            <i *ngIf="iconStyle === 'globe'" class="ph ph-caret-down"></i>
        </a>
        <ul class="dropdown-menu animation-dock">
            <li *ngIf="currentLanguageLabel !== 'English'">
                <a (click)="requestLanguageChange('en')" class="language-option" style="cursor: pointer">
                    <img *ngIf="iconStyle === 'flag'" [src]="getFlagUrl('gb')" width="24" height="16"
                        style="margin-right: 6px; border-radius: 5px;" />
                    English
                </a>
            </li>
            <li *ngIf="currentLanguageLabel !== 'Français'">
                <a (click)="requestLanguageChange('fr')" class="language-option" style="cursor: pointer">
                    <img *ngIf="iconStyle === 'flag'" [src]="getFlagUrl('fr')" width="24" height="16"
                        style="margin-right: 6px; border-radius: 5px;" />
                    Français
                </a>
            </li>
             <li *ngIf="currentLanguageLabel !== 'हिन्दी'">
                <a (click)="requestLanguageChange('hi')" class="language-option" style="cursor: pointer">
                    <img *ngIf="iconStyle === 'flag'" [src]="getFlagUrl('in')" width="24" height="16"
                        style="margin-right: 6px; border-radius: 5px;" />
                    हिन्दी
                </a>
            </li>
        </ul>
    </li>
</ul>


<!-- Confirmation Modal - use language-confirm-backdrop to avoid groups.component.css hiding it -->
<div class="language-confirm-backdrop" *ngIf="showConfirmModal" (click)="cancelLanguageChange()">
  <div class="modal-language-confirm">
    <p>{{ 'areYouSureYouWantToChangeTheLanguage' | translate }} {{selectedLanguage}} ?</p>
    <div class="modal-actions">
        <button (click)="cancelLanguageChange()">No</button>
      <button (click)="confirmLanguageChange()">Yes</button>
    </div>
  </div>
</div>